import {
  StyledGridLabelValue,
  StyledRowItemsWrapper,
  StyledTh,
} from '@/components/sections/service/maintenance-list/table/full';
import { StyledScrollSnapWrapper } from '@/components/sections/service/maintenance-list/table/full/scrollbar';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Grid } from '@/components/shared/layout/grid';
import { formatPrice } from '@/components/shared/utility/format';
import { RegularMaintenaceSchedule } from '@/types/services/contentstack/services/maintenance-service';

interface MaintenanceListTableFullTheadProps {
  headerLabelTitle: string;
  headerLengthTitle: string;
  maintenanceSchedules: RegularMaintenaceSchedule[];
  selectedIndex?: number;
}

export const MaintenanceListTableFullThead = (
  props: MaintenanceListTableFullTheadProps
) => {
  return (
    <StyledGridLabelValue
      top="sticky-top"
      position="sticky"
      backgroundColor="white"
      css={{
        zIndex: '15',
        borderTopLeftRadius: '$rounded-2',
        borderTopRightRadius: '$rounded-2',
      }}
      overflow="hidden"
      data-test="maintenance_tableHead"
    >
      <StyledTh isLabel>
        <Text size="text-body-1" font="bold" variant="text-current">
          {props.headerLabelTitle}
        </Text>
      </StyledTh>
      <Box>
        <Grid templateColumns="1" rowGap="0-5">
          <StyledTh>
            <Text
              size={{
                '@initial': 'text-base-2',
                '@sm': 'text-base',
              }}
              font="bold"
              variant="text-current"
            >
              {props.headerLengthTitle}
            </Text>
          </StyledTh>
          <StyledScrollSnapWrapper>
            <StyledRowItemsWrapper className="scrollable-area">
              {props.maintenanceSchedules.map((schedule, index) => (
                <Grid
                  key={`headerSlide${index}`}
                  templateColumns="1"
                  rowGap="0-5"
                >
                  <StyledTh
                    isTableValueCell
                    isActive={index === props.selectedIndex}
                  >
                    <Text
                      css={{
                        marginBottom: '-2px',
                      }}
                      size="text-base-2"
                      font="bold"
                      variant="text-current"
                    >
                      {formatPrice(schedule.mileage, false)}
                    </Text>
                  </StyledTh>
                  <StyledTh
                    isTableValueCell
                    isActive={index === props.selectedIndex}
                  >
                    <Text
                      css={{
                        marginBottom: '-2px',
                      }}
                      size="text-base-2"
                      font="bold"
                      variant="text-current"
                    >
                      {schedule.month}
                    </Text>
                  </StyledTh>
                </Grid>
              ))}
            </StyledRowItemsWrapper>
          </StyledScrollSnapWrapper>
        </Grid>
      </Box>
    </StyledGridLabelValue>
  );
};

MaintenanceListTableFullThead.displayName =
  'SectionMaintenanceListTableFullThead';
